import {IErrorModel} from "src/context/states/IErrorModel";

export enum Region {
    NA = "NA",
    EU = "EU",
    FE = "FE"
};

export interface ISession {
    region: Region
}

export interface ISessionState {
    data: ISession
}